import {
  AssignmentCancelTypeEnum,
  AssignmentDeviationEnum,
  AssignmentViewModel,
  CaseTypeEnum,
} from 'api/model';
import { isSameDay } from 'date-fns';

const standByCancellations = [
  AssignmentCancelTypeEnum.CanceledNotStartedSameDay,
  AssignmentCancelTypeEnum.CanceledNotArrived,
  AssignmentCancelTypeEnum.CanceledArrived,
] as AssignmentCancelTypeEnum[];

// eslint-disable-next-line import/prefer-default-export
export function validateMoveToApproved(
  viewModel: AssignmentViewModel
): string[] {
  if (
    (
      [
        AssignmentDeviationEnum.Canceled,
        AssignmentDeviationEnum.Discarded,
      ] as AssignmentDeviationEnum[]
    ).includes(viewModel.assignment.assignmentDeviationID)
  ) {
    if (
      viewModel.assignment.assignmentDeviationID ===
        AssignmentDeviationEnum.Canceled &&
      viewModel.assignment.assignmentCancelTypeID !==
        AssignmentCancelTypeEnum.CanceledNotArrived && // cancelled not arrived should be checked however
      viewModel.assignment.assignmentCancelTypeID !==
        AssignmentCancelTypeEnum.CanceledNotStartedSameDay // cancelled not arrived should also be checked
    ) {
      return []; // no checks needed for cancelled and discarded assignments
    }
  }

  if (
    viewModel.assignment.assignmentCancelTypeID ===
      AssignmentCancelTypeEnum.CanceledNotStartedSameDay &&
    (isSameDay(viewModel.assignment.bookedTo, new Date()) ||
      viewModel.assignment.bookedTo > new Date())
  ) {
    return [
      'Avbok ej påbörjat (samma dag) kan inte godkännas förrän dagen efteråt.',
    ];
  }

  if (
    viewModel.assignment.assignmentCancelTypeID &&
    standByCancellations.includes(
      viewModel.assignment.assignmentCancelTypeID
    ) &&
    viewModel.assignment.isStandbyEligible === null
  ) {
    return [
      'Du måste sätta om fälttestaren ska ha standby-tid eller inte för avbokade uppdraget.',
    ];
  }

  if (
    viewModel.assignment.assignmentCancelTypeID ===
      AssignmentCancelTypeEnum.CanceledNotStartedSameDay &&
    viewModel.assignment.isStandbyEligible === true &&
    viewModel.assignment.standByAssignmentTime === null
  ) {
    return [
      'Uppdraget har markerat "ja" för standby-tid. Standby-tid behöver då sättas innan uppdraget kan godkännas.',
    ];
  }
  const checks: [checkFailed: boolean, message: string][] = [
    [!viewModel.case.company, 'Ange företag för att godkänna uppdraget.'],
    [
      !viewModel.assignment.startTime,
      'Ange starttid för att godkänna uppdraget.',
    ],
    [!viewModel.assignment.endTime, 'Ange sluttid för att godkänna uppdraget.'],
    [
      !viewModel.assignment.assignedTo &&
        viewModel.assignment.loadedByTransportCount === 0,
      'Ange fälttestare för att godkänna uppdraget.',
    ],
  ];

  switch (viewModel.case.caseTypeID) {
    case CaseTypeEnum.HomeDelivery: {
      checks.push([
        // Orval leaves backend null as null (NSwag mapped it to undefined),
        // so a strict undefined check would let county-less assignments through
        !viewModel.assignment.toCounty,
        'Ange till vilket län fordonet skall levereras (Till, län) för att godkänna uppdraget.',
      ]);
      break;
    }

    case CaseTypeEnum.Purchase:
    case CaseTypeEnum.Auction: {
      checks.push([
        !viewModel.assignment.fromCounty,
        'Ange i vilket län inköpet skall ske (Från, län) för att godkänna uppdraget.',
      ]);
      break;
    }

    default: {
      break;
    }
  }

  return checks.filter(([failed]) => failed).map(([, message]) => message);
}
